import { alphanumericSort } from 'src/pages/analytics/simulator/innovation/utils/utils';
import { FormControlLabel, Radio, RadioGroup, Slider, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import DateRangePicker from 'rsuite/esm/DateRangePicker';
import {
  FormField2,
  IDynamicFormValue,
  IMultiSelectControlField2,
  ISliderInputField
} from 'src/lib';
import SimpleSelectComponent from '../multi-select/select.component';
import TextAreaFieldControl from '../text-field/free-text-area-field';
import FreeTextFieldControl from '../text-field/free-text-field';
import NumberFieldControl from '../text-field/number-field';
import ToggleFieldControl from '../toggle-field/toggle-field';

interface IDynamicFormFieldRendererProps {
  field: FormField2;
  form: FormikProps<IDynamicFormValue>;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
  errorMessage?: (value: string) => void;
  handleRadioChange?: (value: string) => void;
}

export default function DynamicFormFieldRenderer({
  field,
  form,
  handleChange,
  handleBlur,
  handleRadioChange,
}: IDynamicFormFieldRendererProps) {
  switch (field.control_type) {
    case 'MULTISELECT-DROPDOWN':
      return (
        <SimpleSelectComponent
          handleChange={(value) => {
            form.setFieldTouched(field.name, false);
            handleChange(value);
          }}
          handleBlur={(expandedState) => {
            if (expandedState === false) {
              form.setFieldTouched(field.name, true, true);
            }
          }}
          limit={(field as IMultiSelectControlField2).limit}
          isDisabled={!field.is_active}
          label={field.alias}
          options={(field as IMultiSelectControlField2).values || []}
          value={form.values[field.name]}
          isMultiSelect
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
        />
      );

    case 'SINGLESELECT-DROPDOWN':
      return (
        <SimpleSelectComponent
          handleChange={handleChange}
          isDisabled={!field.is_active}
          label={field.alias}
          options={(field as IMultiSelectControlField2).values || []}
          // options={
          //   alphanumericSort((field as IMultiSelectControlField2).values) || []
          // }
          value={form.values[field.name]}
          isMultiSelect={false}
          handleBlur={(expandedState) => {
            if (expandedState === false) {
              form.setFieldTouched(field.name, true, true);
            }
          }}
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
        />
      );

    case 'TEXT':
      return (
        <FreeTextFieldControl
          handleChange={handleChange}
          handleBlur={(e) => {
            form.setFieldTouched(field.name, true, true);
            form.handleBlur(e);
          }}
          label={field.alias}
          value={(form.values[field.name] as string) || ''}
          isDisabled={!field.is_active}
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
        />
      );

    case 'NUMBER':
      return (
        <NumberFieldControl
          handleChange={handleChange}
          handleBlur={(e) => {
            form.setFieldTouched(field.name, true, true);
            form.handleBlur(e);
          }}
          label={field.alias}
          value={form.values[field.name] as number}
          isDisabled={!field.is_active}
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
          prefixValue={field.prefix_label}
          suffixValue={field.suffix_label}
        />
      );

    case 'PERCENTAGE':
      return (
        <NumberFieldControl
          handleChange={handleChange}
          handleBlur={(e) => {
            form.setFieldTouched(field.name, true, true);
            form.handleBlur(e);
          }}
          label={field.alias}
          value={form.values[field.name] as number}
          isDisabled={!field.is_active}
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
          prefixValue={field.prefix_label}
          suffixValue={field.suffix_label}
        />
      );

    case 'TEXT-AREA':
      return (
        <TextAreaFieldControl
          handleChange={handleChange}
          handleBlur={(e) => {
            form.setFieldTouched(field.name, true, true);
            form.handleBlur(e);
          }}
          label={field.alias}
          value={(form.values[field.name] as string) || ''}
          isDisabled={!field.is_active}
          error={
            form.touched[field.name]
              ? (form.errors[field.name] as string)
              : null
          }
        />
      );

    case 'TOGGLE':
      return (
        <ToggleFieldControl
          handleChange={(value) => {
            handleChange(value);
            form.setFieldTouched(field.name, true, true);
          }}
          label={{
            toggle1: 'Existing PPGs',
            toggle2: 'New PPG'
          }}
          value={Boolean(form.values[field.name])}
          isDisabled={false}
        />
      );

    case 'DATE-RANGE':
      return (
        <DateRangePicker
          style={{ width: '100%', marginTop: '0PX' }}
          onChange={(value) => {
            handleChange(value);
          }}
          value={(form.values[field.name] as any) || ''}
          placement='auto'
        />
      );

    case 'SLIDER-INPUT':
      return (
        <div className='input-master-div'>
          <div className='input-div' style={{ padding: '0 8px' }}>
            <Slider
              aria-label='Spends'
              value={
                form.values[field.name] === undefined
                  ? 0
                  : form.values[field.name]
              }
              onChange={(_event, val) => handleChange(val)}
              valueLabelDisplay='auto'
              step={1}
              size='small'
              min={0}
              max={(field as ISliderInputField).upperbound_limit}
              sx={{ width: '100%' }}
            />
          </div>
        </div>
      );
    default:
      return;
  }
}
